import { Linking, Pressable, StyleSheet } from 'react-native'

import { StatusIcon } from '../icons/StatusIcon'
import { useFunkitTranslation } from '../providers/FunkitI18nProvider'
import { Box, Text, useTheme } from '../theme/restyle'

const FUN_REGIONAL_RESTRICTIONS_URL =
  'https://intercom.help/funxyz/en/articles/9827689-regional-restrictions'

export function CheckoutBlockedScreen() {
  const { t } = useFunkitTranslation()
  const theme = useTheme()
  return (
    <Box
      borderTopLeftRadius="modal"
      borderTopRightRadius="modal"
      style={{ backgroundColor: theme.background.modal }}
    >
      <Box alignItems="center" style={styles.topBar}>
        <Box
          style={[
            styles.grabber,
            { backgroundColor: theme.border.elements.default.color },
          ]}
        />
        <Text
          variant="bodyMedium"
          style={{ color: theme.content.elements.primary }}
        >
          {t('selectMethod.title')}
        </Text>
      </Box>

      <Box alignItems="center" justifyContent="center" style={styles.content}>
        <StatusIcon />
        <Box alignItems="center" style={styles.textGroup}>
          <Text
            variant="bodyMedium"
            style={{ color: theme.content.elements.primary }}
          >
            {t('checkoutBlocked.notAvailable')}
          </Text>
          <Box alignItems="center">
            <Text
              variant="detail"
              style={[
                styles.descriptionText,
                { color: theme.content.elements.secondary },
              ]}
            >
              {t('checkoutBlocked.regionMessage')}
            </Text>
            <Pressable
              onPress={() => Linking.openURL(FUN_REGIONAL_RESTRICTIONS_URL)}
            >
              <Text
                variant="detail"
                style={[
                  styles.linkText,
                  { color: theme.content.elements.secondary },
                ]}
              >
                {t('checkoutBlocked.viewRegions')}
              </Text>
            </Pressable>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const styles = StyleSheet.create({
  topBar: { height: 64, paddingTop: 25, paddingBottom: 12 },
  grabber: {
    position: 'absolute',
    top: 8,
    width: 36,
    height: 5,
    borderRadius: 999,
  },
  content: {
    height: 390,
    gap: 24,
    paddingHorizontal: 16,
    paddingBottom: 34,
  },
  textGroup: { gap: 8 },
  descriptionText: { textAlign: 'center' },
  linkText: { textAlign: 'center', textDecorationLine: 'underline' },
})
